import React, { useState } from 'react';
import arrowDown from 'assets/icons/chevron-down.svg';
import arrowUp from 'assets/icons/chevron-up.svg';
import { AAMBeaconButton } from 'components/shared/Beacon';
import './EditModal.scss';

export const ExpandableText = ({ primaryText = '', secondaryText = '', hasExpandableText }) => {
  const [showReadMore, setShowReadMore] = useState(false);

  return (
    <div className="cost-basis-note-container">
      <div className="cost-basis-note-container-msg">{primaryText}</div>
      {hasExpandableText && (
        <div className="cost-basis-read-more-button">
            <AAMBeaconButton
                variant="tertiary"
                onBeaconEventClick={() => setShowReadMore(!showReadMore)}
            >
                Read More
            </AAMBeaconButton>
            <img
                src={showReadMore ? arrowUp : arrowDown}
                alt="toggle"
                width={20}
                height={20}
                onClick={() => setShowReadMore(!showReadMore)}
            />
        </div>
      )}
      {showReadMore && (
        <div className="cost-basis-read-more-text">{secondaryText}</div>
      )}
    </div>
  );
};
